module.exports = __webpack_public_path__ + "img/upload_icon_grey.72887fed.svg";